import settings from '../utilities/settings';

const ASSOBAY_CONTENT_PATHS = {
  terms: '/it/content/8-termini-e-condizioni-di-utilizzo-del-servizio?from=landing',
  privacy: '/it/content/12-informativa-sulla-privacy?from=landing',
  cookie: '/it/content/13-cookie?from=landing',
  convenzioneAttEcon: '/it/content/10-convenzione-per-le-attivita-economiche?from=landing',
  convenzioneAssoc: '/it/content/6-convenzione-per-le-associazioni?from=landing',
  associations: '/it/module/ps_assobaycore/associations',
} as const;

export type AssobayLegalLinkKey = keyof typeof ASSOBAY_CONTENT_PATHS;

export const getAssobayLegalUrl = (key: AssobayLegalLinkKey): string =>
  `${settings.InfosWebsiteAssoBay.Url}${ASSOBAY_CONTENT_PATHS[key]}`;

export const assobayLegalLinkProps = (key: AssobayLegalLinkKey) => ({
  href: getAssobayLegalUrl(key),
  target: '_blank' as const,
  rel: 'noopener noreferrer',
  style: { color: 'inherit', textDecoration: 'underline' as const },
});
